import Player from './AudioPlayerComp'
import Sketch from './AnimationTwo'
import About from './About'
import Navbar from './Navbar'
import Contact from './Contact'
import Writings from './Writings'
import { Routes, Route } from 'react-router-dom'
import Home from './Home'
import './styles.scss'

function App() {
  return (
    <>
      <Player />
      <div>
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/writings" element={<Writings />} />
        </Routes>
      </div>
      <div className="sketch">
        <Sketch />
      </div>
    </>
  )
}

export default App
